// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__3s5AZ","modalFooterButton":"ModalNotes_modalFooterButton__1ngkp"};